<template>
  <div>
    <div class="col-6 text-center mb-4">
      <!-- <hr /> -->
      <!-- <hr /> -->
    </div>
    <CCardBody>
      <div>
        <strong>Platform Email Configuration</strong>
        <p>
          Configure your email settings here to send messages from your own address through our platform. This ensures
          that recipients see your name and email when receiving messages.
          Some details you provide (such as your sending address) will be shared with our email delivery provider in
          order to verify and authorize sending.
        </p>
      </div>
      <div class="row mt-2">
        <!-- <div class="col-12">
          <div class="row">
            <div class="col-md-6 my-1">
              <div class=" d-flex align-items-end">
                <b-form-group label-for="sendgrid_api_key" class="flex-grow-1 mb-0">
                  <label class="required">SENDGRID API KEY</label>
                  <b-form-input :disabled="sendgrid_verify_token" id="sendgrid_api_key" v-model="form.sendgrid_from_name"
                    v-validate="{ required: true }" name="sendgrid_api_key"
                    aria-describedby="sendgrid_api_key-feedback"></b-form-input>
                </b-form-group>
              </div>
              <div v-if="errors && errors.first('sendgrid_api_key')" class="error_msg">
                SendGrid API Key is required
              </div>
            </div>
          </div>
        </div> -->
        <div class="col-6">
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-md-12 my-1">
                  <div class=" d-flex align-items-end">
                    <b-form-group label-for="sendgrid_from_name" class="flex-grow-1 mb-0">
                      <label class="required">FROM NAME</label>
                      <b-form-input :disabled="sendgrid_verify_token" id="sendgrid_from_name"
                        v-model="form.sendgrid_from_name" v-validate="{ required: true }" name="sendgrid_from_name"
                        placeholder="The name recipients will see as the sender. Example: “Custimoo Support”."
                        aria-describedby="sendgrid_from_name-feedback"></b-form-input>
                    </b-form-group>
                  </div>
                  <div v-if="errors && errors.first('sendgrid_from_name')" class="error_msg">
                    From Name is required
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-md-12 my-1">
                  <div class=" d-flex align-items-end">
                    <b-form-group label-for="sendgrid_from_address" class="flex-grow-1 mb-0">
                      <label class="required">FROM ADDRESS</label>
                      <b-form-input :disabled="sendgrid_verify_token" id="sendgrid_from_address"
                        v-model="form.sendgrid_from_address" v-validate="{ email: true, required: true }"
                        name="sendgrid_from_address" placeholder="The email address used to send messages"
                        aria-describedby="sendgrid_from_address-feedback" @mouseover="showInputTooltip = true"
                        @mouseleave="showInputTooltip = false" />
                      <!-- <span
                    v-if="showInputTooltip"
                    class="input-tooltip"
                    style="position: absolute; background: #333; color: #fff; padding: 4px 8px; border-radius: 4px; left: 0; top: 100%; z-index: 10;"
                  >
⚠️ After entering your email, click Send Verification Email. You’ll receive a confirmation email with a link you must copy paste here before sending can be activated.</span> -->
                    </b-form-group>
                    <b-tooltip target="sendgrid-verification-btn" triggers="hover" placement="top">
                      Disclaimer: Your email will be securely shared with our delivery provider for verification
                      purposes only.
                    </b-tooltip>
                    <button id="sendgrid-verification-btn" class="btn btn-primary ml-2"
                      :disabled="sendgrid_verify_token || sendgrid_verified" @click.prevent="sendSendgridVerificationMail">
                      Send Verification Email
                    </button>
                  </div>
                  <div v-if="errors && errors.first('sendgrid_from_address')" class="error_msg">
                    From Address should be proper email
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-2 mt-2">
                  <span>
                    After entering your email, click Send Verification Email. You’ll receive a confirmation email with a
                    link you must copy and then paste in the Verification input field below. Once that is done click on
                    "Save" to store the information.
                  </span>
                </div>
              </div>
            </div>
            <!-- <div class="col-12">
          <div class="row">
            <div class="col-md-6 my-1">
              <div class=" d-flex align-items-end">
                <b-form-group label-for="sendgrid_reply_to" class="flex-grow-1 mb-0">
                  <label class="required">REPLY TO</label>
                  <b-form-input  :disabled="sendgrid_verify_token" id="sendgrid_reply_to" v-model="form.sendgrid_reply_to"
                    v-validate="{ email:true,required: true }" name="sendgrid_reply_to"
                    placeholder="The email where replies will be sent. This can be the same as your From Address or a different inbox."
                    aria-describedby="sendgrid_reply_to-feedback"></b-form-input>
                </b-form-group>
              </div>
              <div v-if="errors && errors.first('sendgrid_reply_to')" class="error_msg">
                Reply To should be proper email
              </div>
            </div>

          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-md-6 my-1">
              <div class=" d-flex align-items-end">
                <b-form-group label-for="sendgrid_reply_to_name" class="flex-grow-1 mb-0">
                  <label class="required">REPLY TO NAME</label>
                  <b-form-input v :disabled="sendgrid_verify_token" id="sendgrid_reply_to_name" v-model="form.sendgrid_reply_to_name"
                    v-validate="{ required: true }" name="sendgrid_reply_to_name"
                    placeholder="The name shown alongside your Reply-To email. Example: “Customer Service Team”."
                    aria-describedby="sendgrid_reply_to_name-feedback"></b-form-input>
                </b-form-group>
              </div>
              <div v-if="errors && errors.first('sendgrid_reply_to_name')" class="error_msg">
                Reply To Name is required
              </div>
            </div>
          </div>
        </div> -->
            <div class="col-12">
              <div class="row">
                <div class="col-md-12 my-1">
                  <div class=" d-flex align-items-end">
                    <b-form-group label-for="sendgrid_reply_to_name" class="flex-grow-1 mb-0">
                      <label class="required">VERIFICATION</label>
                      <b-form-input :disabled="!sendgrid_verify_token" id="sendgrid_verification_url"
                        v-model="form.sendgrid_verification_url" v-validate="{ required: true }"
                        name="sendgrid_verification_url"
                        placeholder="Paste the full URL from the verification email here"
                        aria-describedby="sendgrid_verification_url-feedback"></b-form-input>
                    </b-form-group>
                  </div>
                  <div v-if="errors && errors.first('sendgrid_verification_url')" class="error_msg">
                    Verfication URL is required
                  </div>
                </div>
              </div>
              <div class="row">
                <!-- <div class="col-12 mb-2 mt-2">
                  <span>
                    <b>Important note:</b> Please update your domain’s SPF record to include our sending service
                    <br/>
                    <code class="code">
                    "v=spf1 include:sendgrid.net -all"
                    </code>
                    <br/> This ensures your emails are authorized and not marked as spam.
                  </span>
                </div> -->
                <div class="col-12 mb-2 mt-2">
                  <span>
                    <b>Important note:</b> Please update your domain’s SPF record to include our sending service. 
                    <br/>
                    Steps are as below:
                    <ul>
                      <li>Log in to your domain registrar and open the DNS settings for your email domain.</li>
                      <li>Find the TXT record that starts with 
                        <code class="code">v=spf1</code></li>
                      <li>Add <code class="code">include:sendgrid.net</code> between <code class="code">v=spf1</code> and <code class="code">~all</code></li>
                      <li>Do not remove any existing entries — just add ours. For example, if your current SPF record looks like this:
                      <code class="code">v=spf1 a -all</code></li>
                      <li>update it to:
                      <code class="code">v=spf1 a include:sendgrid.net ~all</code></li>
                      <li>Save or create the record to apply your changes.</li>
                    </ul>
                  </span>
                </div>
                <div class="col-12 mb-2 mt-2">
                  <span>
                    Disclaimer: Your email will be securely shared with our delivery provider for verification purposes
                    only.
                  </span>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="col-6" v-if="!sendgrid_verified">
          <img src="@/assets/images/email-configuration-info.jpeg" alt="SendGrid Email Configuration Hint"
            style="max-width: 100%; height: auto;" />
        </div>
      </div>
      <div class="col-6">
        <div class="row my-1">
          <button class="btn btn-primary mr-2" :disabled="form.sendgrid_verification_url === ''"
            @click.prevent="verifySendGridTokenAndSaveSettings">Save</button>
          <button class="btn btn-primary ml-2" @click.prevent="resetSendgridSettings"
            :disabled="!sendgrid_enabled">Reset</button>
          <template v-if="sendgrid_verified">
            <button class="btn btn-primary ml-2" @click.prevent="toggleEmailVerificationField" :disabled="!sendgrid_verified">
              Send Test Email
              <CIcon :name="'cil-check-circle'" :style="'color:white; margin: 0rem 2 rem'"
                v-if="sendgrid_enabled && sendgrid_verify_token" />
            </button>
          </template>
        </div>
        <div class="row" v-if="verifySendgrid">
          <div class="col-md-12 my-1 pl-0">
            <div class=" d-flex align-items-end">
              <b-form-group label-for="test_email_address" class="flex-grow-1 mb-0">
                <label class="required">Test Email Address</label>
                <b-form-input id="test_email_address"
                  v-model="form.test_from_address" v-validate="{ email: true, required: true }"
                  name="test_email_address" placeholder="The email address used as test email address to receive test email"
                  aria-describedby="test_email_address-feedback" @mouseover="showInputTooltip = true"
                  @mouseleave="showInputTooltip = false" />
                <!-- <span
                    v-if="showInputTooltip"
                    class="input-tooltip"
                    style="position: absolute; background: #333; color: #fff; padding: 4px 8px; border-radius: 4px; left: 0; top: 100%; z-index: 10;"
                  >
⚠️ After entering your email, click Send Verification Email. You’ll receive a confirmation email with a link you must copy paste here before sending can be activated.</span> -->
              </b-form-group>
              <!-- <b-tooltip target="email-verification-btn" triggers="hover" placement="top">
                Disclaimer: Your email will be securely shared with our delivery provider for verification
                purposes only.
              </b-tooltip> -->
              <button id="email-verification-btn" @click.prevent="sendSendgridTestMail" class="btn btn-primary ml-2">
                Send Test Email
              </button>
            </div>
            <div v-if="errors && errors.first('sendgrid_from_address')" class="error_msg">
              From Address should be proper email
            </div>
          </div>
        </div>
      </div>
    </CCardBody>
    <CCardBody>
      <div>
        <strong>Email Configuration</strong>
        <p>This below form lets you connect your email server (smtp server), so the system can send emails for you, like
          password resets, notifications, and updates. Just fill in your email details here, and once set up, the system
          will deliver emails using your smtp server.</p>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-6 my-1">
              <b-form-group id="mail_host" label-for="mail_host">
                <label class="required">MAIL HOST</label>
                <b-form-input id="mail_host" v-model="form.mail_host" v-validate="{ required: true }" name="mail_host"
                  aria-describedby="mail_host-feedback"></b-form-input>
                <div v-if="errors && errors.first('mail_host')" class="error_msg">
                  Mail Host is required
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-md-6 my-1">
              <b-form-group id="sku-number" label-for="mail_port">
                <label class="required">MAIL PORT</label>
                <b-form-input id="mail_port" v-model="form.mail_port" v-validate="{ required: true }" name="mail_port"
                  aria-describedby="mail_port-feedback"></b-form-input>
                <div v-if="errors && errors.first('mail_port')" class="error_msg">
                  Mail Port is required
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-md-6 my-1">
              <b-form-group id="sku-number" label-for="mail_username">
                <label class="required">MAIL USERNAME</label>
                <b-form-input id="mail_username" v-model="form.mail_username" v-validate="{ required: true }"
                  name="mail_username" aria-describedby="mail_username-feedback"></b-form-input>
                <div v-if="errors && errors.first('mail_username')" class="error_msg">
                  Mail Username is required
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-md-6 my-1">
              <b-form-group label-for="mail_password">
                <label class="required">MAIL PASSWORD</label>
                <b-form-input id="mail_password" v-model="form.mail_password" v-validate="{ required: true }"
                  type="password" name="mail_password" aria-describedby="mail_password-feedback"></b-form-input>
                <div v-if="errors && errors.first('mail_password')" class="error_msg">
                  Mail password is required
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-md-6 my-1">
              <b-form-group label-for="mail_encryption">
                <label class="required">MAIL ENCRYPTION</label>
                <b-form-input id="mail_encryption" v-model="form.mail_encryption" name="mail_encryption"
                  aria-describedby="mail_encryption-feedback"></b-form-input>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-md-6 my-1">
              <b-form-group label-for="mail_from_address">
                <label class="required">MAIL FROM ADDRESS</label>
                <b-form-input id="mail_from_address" v-model="form.mail_from_address" v-validate="{ required: true }"
                  name="mail_from_address" aria-describedby="mail_from_address-feedback"></b-form-input>
                <div v-if="errors && errors.first('mail_from_address')" class="error_msg">
                  Mail from address is required
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-md-6 my-1">
              <b-form-group label-for="mail_from_name">
                <label class="required">MAIL FROM NAME</label>
                <b-form-input id="mail_from_name" v-model="form.mail_from_name" v-validate="{ required: true }"
                  name="mail_from_name" aria-describedby="mail_from_name-feedback"></b-form-input>
                <div v-if="errors && errors.first('mail_from_name')" class="error_msg">
                  Mail from name is required
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row my-1">
          <button class="btn btn-primary mr-2" @click.prevent="submit">Save</button>
          <button class="btn btn-primary ml-2" @click.prevent="reset"
            :disabled="this.form.mail_from_name === ''">Reset</button>
          <template>
            <button class="btn btn-primary ml-2" @click.prevent="verify"
              :disabled="this.form.mail_from_name === '' || verification_success">
              Verify Settings
              <CIcon :name="'cil-check-circle'" :style="'color:white; margin: 0rem 2 rem'"
                v-if="verification_success" />
            </button>
          </template>
        </div>
      </div>
    </CCardBody>
  </div>
</template>
<script>
export default {
  async created() {
    try {
      await this.getEmailConfiguration();
    } catch (err) {
      this.showToast(err.messaage, 'DANGER');
    }
  },
  computed: {
    form_valid() {
      return this.$validator.validate();
    }
  },
  data() {
    return {
      showInputTooltip: false,
      form: {
        mail_host: '',
        mail_port: '',
        mail_username: '',
        mail_password: '',
        mail_encryption: '',
        mail_from_address: '',
        mail_from_name: '',
        sendgrid_from_address: '',
        sendgrid_from_name: '',
        sendgrid_reply_to_name: '',
        sendgrid_reply_to: '',
        sendgrid_verification_url: '',
        // sendgrid_api_key:'',
      },
      sendgrid_verify_token: false,
      verification_success: false,
      send_sendgrid_verification: false,
      sendgrid_enabled: false,
      sendgrid_verified: false,
      verifySendgrid:false,
      // sendgrid_verification_success: false,
    }
  },
  methods: {
    ResetForm() {
      this.form.mail_host = '';
      this.form.mail_port = '';
      this.form.mail_username = '';
      this.form.mail_password = '';
      this.form.mail_encryption = '';
      this.form.mail_from_address = '';
      this.form.mail_from_name = '';
      this.form.sendgrid_from_address = '';
      this.form.sendgrid_from_name = '';
      this.form.sendgrid_reply_to_name = '';
      this.form.sendgrid_reply_to = '';
      // this.sendgrid_verification_success = false;
      this.sendgrid_verify_token = false;
      this.sendgrid_enabled = false;
      this.sendgrid_verified = false;
      this.verifySendgrid = false;
    },
    toggleEmailVerificationField() {
      this.verifySendgrid = !this.verifySendgrid;
    },
    async sendSendgridTestMail(){
      let valid = await this.$validator.validateAll(['test_from_address']);
      if (valid) {
        await this.$store.commit('set', ['showLoader', true]);
        try {
          let res = await this.$store.dispatch('sendSendgridTestMail', {
            form: {
              test_email_address: this.form.test_from_address,
            }
          });
          if (res.data.status_code === 200) {
            this.showToast('Test email sent successfully', 'SUCCESS');
          } else if (res.data.status_code === 500) {
            this.showToast(res.data.message, 'ERROR')
          }
          else {
            this.showToast('Something went wrong', 'ERROR')
          }
          this.$store.commit('set', ['showLoader', false]);
        } catch (err) {
          this.$store.commit('set', ['showLoader', false]);
          this.showErrors(err);
        }
      }
      else {
        this.showToast('Please provide valid email address to send test email', 'ERROR')
      }
    },
    async reset() {
      await this.$store.commit('set', ['showLoader', true]);
      try {
        let res = await this.$store.dispatch(`deleteConfiguration`, 'email');
        if (res.data.status_code === 200) {
          this.ResetForm()
          let reset = await this.$validator.reset();
          this.showToast('Configuration reset successfully', 'SUCCESS');
        } else {
          this.showToast('Something went wrong', 'ERROR')
        }
        this.$store.commit('set', ['showLoader', false]);
      } catch (err) {
        this.$store.commit('set', ['showLoader', false]);
        this.showErrors(err);
      }
    },
    async submit() {

      // Only validate specific fields
      let valid = await this.$validator.validateAll([
        'mail_host',
        'mail_port',
        'mail_username',
        'mail_password',
        'mail_from_address',
        'mail_from_name'
      ]);
      if (valid) {
        await this.$store.commit('set', ['showLoader', true]);
        try {
          let res = await this.$store.dispatch('saveConfiguration', {
            settings: [
              {
                key: 'email',
                value: this.form
              }
            ]
          });
          if (res.data.status_code === 200) {
            const email_settings = res.data.result.find(setting => setting.key_name === "email");
            this.form.mail_from_address = email_settings.value.mail_from_address;
            this.form.mail_from_name = email_settings.value.mail_from_name;
            this.form.mail_host = email_settings.value.mail_host;
            this.form.mail_port = email_settings.value.mail_port;
            this.form.mail_username = email_settings.value.mail_username;
            this.form.mail_password = email_settings.value.mail_password;
            this.form.mail_encryption = email_settings.value.mail_encryption;
            this.showToast('Configuration saved successfully', 'SUCCESS');
          } else {
            this.showToast('Something went wrong', 'ERROR')
          }
          this.$store.commit('set', ['showLoader', false]);
        } catch (err) {
          this.$store.commit('set', ['showLoader', false]);
          this.showErrors(err);
        }
      }
    },
    async getEmailConfiguration() {
      await this.$store.commit('set', ['showLoader', true]);
      try {
        let res = await this.$store.dispatch('getConfiguration', 'email');
        if (res.data.status_code === 200) {
          if (Object.keys(res.data.result).length !== 0) {
            this.form = res.data.result;
          }
        } else {
          this.showToast('Configuration not set yet', 'ERROR')
        }

        res = await this.$store.dispatch('getConfiguration', 'sendgrid');
        if (res.data.status_code === 200) {
          if (Object.keys(res.data.result).length !== 0) {
            this.form.sendgrid_from_address = res.data.result.verified_email;
            this.form.sendgrid_from_name = res.data.result.verified_name;
            this.form.sendgrid_reply_to = res.data.result.reply_to;
            this.form.sendgrid_reply_to_name = res.data.result.reply_to_name;
            // this.sendgrid_verification_success = res.data.result.is_verified;
            this.sendgrid_verify_token = !res.data.result.is_verified;
            this.sendgrid_verified = res.data.result.is_verified;

            this.sendgrid_enabled = res.data.result.enabled;
          }
        } else {
          this.showToast('Configuration not set yet', 'ERROR')
        }

        this.$store.commit('set', ['showLoader', false]);
      } catch (err) {
        this.$store.commit('set', ['showLoader', false]);
        this.showErrors(err);
      }
    },
    async verify() {
      let valid = await this.$validator.validate();
      if (valid) {
        await this.$store.commit('set', ['showLoader', true]);
        try {
          let res = await this.$store.dispatch('verifySMTPSettings', {
            form: this.form
          });
          if (res.data.status_code === 200) {
            this.verification_success = true;
            this.showToast('Email successfully sent', 'SUCCESS');
          } else if (res.data.status_code === 500) {
            this.verification_success = false;
            this.showToast(res.data.message, 'ERROR')
          }
          else {
            this.verification_success = true;
            this.showToast('Something went wrong', 'ERROR')
          }
          this.$store.commit('set', ['showLoader', false]);
        } catch (err) {
          this.verification_success = false;
          this.$store.commit('set', ['showLoader', false]);
          this.showErrors(err);
        }
      }
      else {
        this.showToast('Please provide valid settings', 'ERROR')
      }
    },
    async verifySendGridTokenAndSaveSettings() {
      let valid = await this.$validator.validateAll(['sendgrid_verification_url']);
      if (valid) {
        await this.$store.commit('set', ['showLoader', true]);
        try {
          let res = await this.$store.dispatch('verifySendgridSettingsAndSave', {
            form: {
              sendgrid_verification_url: this.form.sendgrid_verification_url,
            }
          });
          if (res.data.status_code === 200) {
            this.sendgrid_verify_token = res.data.result.enabled;
            this.sendgrid_verified = res.data.result.is_verified;

            this.showToast('Settings saved successfully', 'SUCCESS');
          } else if (res.data.status_code === 500) {
            this.showToast(res.data.message, 'ERROR')
          }
          else {
            this.showToast('Something went wrong', 'ERROR')
          }
          this.$store.commit('set', ['showLoader', false]);
        } catch (err) {
          this.$store.commit('set', ['showLoader', false]);
          this.showErrors(err);
        }
      }
    },
    async sendSendgridVerificationMail() {
      let valid = await this.$validator.validateAll(['sendgrid_from_address', 'sendgrid_from_name']);
      if (valid && this.form.sendgrid_from_address !== '') {
        this.send_sendgrid_verification = true;

        await this.$store.commit('set', ['showLoader', true]);
        try {
          let res = await this.$store.dispatch('sendgridSenderVerification', {
            form: {
              sendgrid_from_address: this.form.sendgrid_from_address,
              sendgrid_from_name: this.form.sendgrid_from_name,
              sendgrid_reply_to: this.form.sendgrid_reply_to,
              sendgrid_reply_to_name: this.form.sendgrid_reply_to_name,
            }
          });
          if (res.data.status_code === 200) {
            this.showToast('Information is saved and an verification email sent successfully', 'SUCCESS');
            // show the token button to verify
            this.sendgrid_verify_token = true;
            this.sendgrid_enabled = true;
          } else if (res.data.status_code === 500) {
            this.showToast(res.data.message, 'ERROR')
          }
          else {
            this.showToast('Something went wrong', 'ERROR')
          }
          this.send_sendgrid_verification = false;
          this.$store.commit('set', ['showLoader', false]);
        } catch (err) {
          this.send_sendgrid_verification = false;
          this.$store.commit('set', ['showLoader', false]);
          this.showErrors(err);
        }
      }
      else {
        this.showToast('Please provide valid SendGrid Configuration', 'ERROR')
      }
    },
    async resetSendgridSettings() {
      await this.$store.commit('set', ['showLoader', true]);
      try {
        let res = await this.$store.dispatch(`deleteConfiguration`, 'sendgrid');
        if (res.data.status_code === 200) {
          this.ResetForm()
          let reset = await this.$validator.reset();
          this.showToast('Configuration reset successfully', 'SUCCESS');
        } else {
          this.showToast('Something went wrong', 'ERROR')
        }
        this.$store.commit('set', ['showLoader', false]);
      } catch (err) {
        this.$store.commit('set', ['showLoader', false]);
        this.showErrors(err);
      }
    },
    showToast(message, variant = null) {
      this.$bvToast.toast(message, {
        title: 'Notification',
        variant: variant,
        solid: true
      })
    },
    showErrors(err) {
      if (err.response && err.response.data && err.response.data.message) {
        this.showToast(err.response.data.message, 'DANGER');
      } else {
        this.showToast('Something went wrong', 'DANGER');
      }
    }
  },
}


</script>
<style lang="scss" scoped>
.add_range span,
.delete_button span {
  cursor: pointer;
}

.delete_button {
  cursor: pointer;
}
.code{
  padding: 0.3rem;display: inline-block;margin: 0.3rem;border: 1px solid #ccc;border-radius: 5px;box-shadow: 5px;
}
</style>
